// https://nuxtjs.org/api/pages-key/
// https://nuxtjs.org/api/components-nuxt
// NOTE: ignore hash, but take path and query into account
export default ({ path, query }) =>
	[path, new URLSearchParams(query).toString()].filter(Boolean).join('?');
